// DS: i7.5
import React from 'react';
import IconWrap from '../../IconWrap';
const CenterAlign = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7 6a1 1 0 001 1h8a1 1 0 000-2H8a1 1 0 00-1 1zm1 13h8a1 1 0 000-2H8a1 1 0 000 2zm-3-6h14a1 1 0 000-2H5a1 1 0 000 2z",
        transform: "matrix(-1 0 0 1 24 0)"
    })));
};
CenterAlign.displayName = 'CenterAlign';
export default CenterAlign;
